module.exports = __webpack_public_path__ + "static/media/VidSectionBackground.60cee58d.webp";